<template>
  <div id="InventoryAnalysis" style="margin: 0px auto">
    <div class="breadcrumb-box">
      <el-breadcrumb separator="/">
        <el-breadcrumb-item>采购管理</el-breadcrumb-item>
        <el-breadcrumb-item>库存分析</el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <div>
      <div ref="availableChartBox" class="chart-box"></div>
      <div ref="chartBox" class="chart-box"></div>
    </div>
    <!-- <div ref="header" class="header-box">
      <div class="header-line">
        <el-button type="primary" size="small" @click="getData">查询</el-button>
      </div>
    </div> -->
    <!-- <div class="main-box">
      <el-table ref="table" :data="dataList" stripe size="mini" :height="screenHeight" :highlight-current-row="true">
        <el-table-column prop="date" label="日期" width="80px" align="center" :key="109"> </el-table-column>
        <el-table-column prop="shopName" label="店铺" width="60px" align="center" :key="111"> </el-table-column>
        <el-table-column prop="planId" label="出库计划编号" width="100px" align="center" :key="110"> </el-table-column>
      </el-table>
    </div> -->

    <!-- <el-pagination ref="pageNav" layout="prev,pager, next" background prev-text="上一页" next-text="下一页" :page-count="pageCount" :page-size="params.pageSize" :total="total" @prev-click="prevBtnClick" @next-click="nextBtnClick" @current-change="curBtnClick"> </el-pagination> -->
  </div>
</template>

<script>
import { requestModules } from "@r";
import * as echarts from "echarts";

export default {
  data() {
    return {
      dataList: [],
      params: {
        beginIndex: 0,
        pageSize: 50,
      },
      total: 0,
      pageCount: 1,
      screenHeight: document.body.clientHeight - 64 - 132 - 68,
      analysisData: {},
    };
  },
  mounted() {
    this.getData();

    this.$eventBus.$on("resize", this.calculateHeight);
  },
  beforeDestroy() {
    this.$eventBus.$off("resize", this.calculateHeight);
  },
  methods: {
    calculateHeight() {
      this.screenHeight = document.body.clientHeight - 64 - 132 - 68;
    },
    getData() {
      requestModules.getInventoryAnalysisData(this.params).then(res => {
        this.planList = res.ldata;

        this.analysisData = res.mdata;
        this.initAvailableChartData();
        this.initChartData();
      });
    },
    initAvailableChartData() {
      let option = {
        title: {
          text: "可用库存",
        },
        xAxis: {
          type: "category",
          data: [],
        },
        yAxis: {
          type: "value",
        },
        series: [
          {
            data: [],
            type: "bar",
          },
        ],
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "cross",
          },
          backgroundColor: "rgba(255, 255, 255, 0.8)",
          extraCssText: "width: 170px",
          formatter: function (params) {
            let result = "库存周期：" + params[0].name + "<br/>" + "商品数量：" + params[0].data + "<br/>";
            return result;
          },
        },
        axisPointer: {
          link: { xAxisIndex: "all" },
          label: {
            backgroundColor: "#777",
          },
        },
        toolbox: {
          feature: {
            dataZoom: {
              yAxisIndex: false,
            },
            brush: {
              type: ["lineX", "clear"],
            },
          },
        },
        brush: {
          xAxisIndex: "all",
          brushLink: "all",
          outOfBrush: {
            colorAlpha: 0.1,
          },
        },
      };

      option.xAxis.data = this.analysisData.availableInventoryAnalysisLabels;
      option.series[0].data = this.analysisData.availableInventoryAnalysisCount;

      var myChart = echarts.init(this.$refs.availableChartBox);
      myChart.setOption(option);
    },
    initChartData() {
      let option = {
        title: {
          text: "亚马逊库存",
        },
        xAxis: {
          type: "category",
          data: [],
        },
        yAxis: {
          type: "value",
        },
        series: [
          {
            data: [],
            type: "bar",
          },
        ],
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "cross",
          },
          backgroundColor: "rgba(255, 255, 255, 0.8)",
          extraCssText: "width: 170px",
          formatter: function (params) {
            let result = "库存周期：" + params[0].name + "<br/>" + "商品数量：" + params[0].data + "<br/>";
            return result;
          },
        },
        axisPointer: {
          link: { xAxisIndex: "all" },
          label: {
            backgroundColor: "#777",
          },
        },
        toolbox: {
          feature: {
            dataZoom: {
              yAxisIndex: false,
            },
            brush: {
              type: ["lineX", "clear"],
            },
          },
        },
        brush: {
          xAxisIndex: "all",
          brushLink: "all",
          outOfBrush: {
            colorAlpha: 0.1,
          },
        },
      };
      option.xAxis.data = this.analysisData.inventoryAnalysisLabels;
      option.series[0].data = this.analysisData.inventoryAnalysisCount;

      var myChart = echarts.init(this.$refs.chartBox);
      myChart.setOption(option);
    },
    getStatusLabel(row) {
      let label = "";
      row.status == 2 && (label = "出库完成");
      row.status == -1 && (label = "已作废");
      row.status == 1 && (label = "出库中");
      return label;
    },

    prevBtnClick() {
      this.handlerPageChange();
    },
    nextBtnClick() {
      this.handlerPageChange();
    },
    curBtnClick() {
      this.handlerPageChange();
    },
    handlerPageChange() {
      let pageNav = this.$refs.pageNav;
      // let lastEmittedPage = pageNav.lastEmittedPage;
      let internalCurrentPage = pageNav.internalCurrentPage;
      this.params.beginIndex = (internalCurrentPage - 1) * this.params.pageSize;
      this.getData();
    },
  },
};
</script>

<style lang="scss">
#InventoryAnalysis {
  .chart-box {
    width: 40%;
    height: 400px;
    display: inline-block;
    background-color: white;
    margin-right: 20px;
  }
  .breadcrumb-box {
    .el-breadcrumb {
      margin: 20px 0px;
      display: inline-block;
      vertical-align: middle;
    }
  }
  .main-box {
    background-color: white;
    padding: 20px;
  }
  .el-table .cell {
    padding-left: 2px;
    padding-right: 2px;
    line-height: 14px;

    .row-item {
      min-height: 14px;
    }

    .redBg {
      background-color: red;
      color: white;
    }
    .yellowBg {
      background-color: yellow;
    }
    .greenBg {
      background-color: green;
      color: white;
    }
    .redText {
      color: red;
    }
    .greenText {
      color: red;
    }
    .greenYellowText {
      color: rgb(233, 104, 104);
    }
    .yellowText {
      color: rgb(112, 56, 56);
    }
  }

  .el-table tr:hover {
    background-color: #f9f981;
  }

  .el-table tr:hover td {
    background-color: transparent;
  }

  .el-table .current-row {
    background-color: #f9f981;

    .el-table__cell {
      background-color: #f9f981;
    }
  }

  .upload-demo {
    text-align: right;
  }
}
</style>
